export type DateRange = {
  from?: Date
  to?: Date
}

export type PickerMode = 'calendar' | 'months' | 'years' | 'hours'

export enum CalendarType {
  Single = 'single',
  Range = 'range'
}
